import * as actionTypes from "../constants";
import { updateObject } from "../../utils";

const initialState = {
  personType: null,
  idType: null,
  idNumber: "",
  email: "",
  businessName: "",
  firstName: "",
  secondName: "",
  firstLastName: "",
  secondLastName: "",
  pin: "",
  pinConfirmation: "",
  response: null,
  activeStep: 0,
  error: false,
};

const setResponse = (state, action) => {
  return updateObject(state, {
    response: action.response,
  });
};

const setField = (state, action) => {
  return updateObject(state, action);
};

const setStep = (state, action) => {
  return updateObject(state, {
    activeStep: action.activeStep,
  });
};

const setPinError = (state, action) => {
  return updateObject(state, {
    error: action.error,
  });
};

const create = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CREATE_RESPONSE:
      return setResponse(state, action);
    case actionTypes.CREATE_SET_FIELD:
      return setField(state, action);
    case actionTypes.CREATE_SET_STEP:
      return setStep(state, action);
    case actionTypes.CREATE_ERROR:
      return setPinError(state, action);
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
};

export default create;
